module.exports = __webpack_public_path__ + "597815ea.svg";